// src/components/PrimerComponente.js
// =============================================================
// Portada/Home visual de la app con:
// - Fondo degradado pastel azul→rosa
// - Título y barra flotante "MASCOTICAS SENA"
// - Galería de 3 imágenes (tus assets locales)
// - 3 botones grandes: MASCOTAS / NOTICIAS / QUIZ
// - Modal con contenido según la sección seleccionada
// - Bloque opcional de botones de admin para exportar (si adminLogueado = true)
// =============================================================

import React, { useState } from "react";
import image1 from "../assets/image1.jpg";
import image2 from "../assets/image2.jpg";
import image3 from "../assets/image3.jpg";

function PrimerComponente({ adminLogueado, exportarUsuarios, exportarLogins }) {
  // -----------------------------------------------------------
  // 1) IMÁGENES DE LA GALERÍA (usa tus assets locales)
  // -----------------------------------------------------------
  const imagenes = [image1, image2, image3];

  // -----------------------------------------------------------
  // 2) ALERTA SIMPLE AL CLIC EN LAS IMÁGENES
  //    (conserva tu comportamiento original)
  // -----------------------------------------------------------
  const mostrarInfo = (nombre) => {
    alert(`Información sobre: ${nombre}`);
  };

  // -----------------------------------------------------------
  // 3) CONTROL DE SECCIONES (abre modal de: MASCOTAS | NOTICIAS | QUIZ)
  // -----------------------------------------------------------
  const [section, setSection] = useState(null); // null = cerrado

  // -----------------------------------------------------------
  // 4) BANCO DE PREGUNTAS DEL QUIZ Y ESTADO DEL QUIZ
  // -----------------------------------------------------------
  const preguntas = [
    {
      q: "¿Cuál vacuna es esencial en perros cachorros?",
      options: ["Moquillo/Parvo", "Influenza humana", "Tétanos", "Varicela"],
      a: 0,
    },
    {
      q: "¿Qué significa FeLV en gatos?",
      options: [
        "Fiebre felina leve",
        "Leucemia felina",
        "Leptospirosis felina",
        "Laringitis felina",
      ],
      a: 1,
    },
    {
      q: "¿Cada cuánto se recomienda desparasitar a una mascota adulta sana?",
      options: ["Cada semana", "Cada 3–4 meses", "Cada 2 años", "Nunca"],
      a: 1,
    },
    {
      q: "¿Qué identifica un microchip?",
      options: ["Raza", "Edad exacta", "Identidad única del animal", "Grupo sanguíneo"],
      a: 2,
    },
    {
      q: "La panleucopenia afecta principalmente a:",
      options: ["Perros", "Gatos", "Aves", "Roedores"],
      a: 1,
    },
    {
      q: "Signo frecuente del parvovirus canino:",
      options: ["Vómito y diarrea hemorrágica", "Estornudos", "Cojera", "Sordera"],
      a: 0,
    },
    {
      q: "Un enrichimiento ambiental felino incluye:",
      options: ["Arena perfumada fuerte", "Rascadores y alturas", "Jaula pequeña", "Luz intensa 24/7"],
      a: 1,
    },
    {
      q: "Las aves requieren con frecuencia:",
      options: ["Dieta solo de semillas", "Variedad con frutas/verduras", "Ayuno semanal", "Sal y azúcar extra"],
      a: 1,
    },
  ];

  const [quizIndex, setQuizIndex] = useState(0);     // índice de la pregunta actual
  const [quizScore, setQuizScore] = useState(0);     // puntaje acumulado
  const [quizFinished, setQuizFinished] = useState(false); // indica si se terminó el quiz

  // Responder una opción del quiz
  const responder = (i) => {
    if (quizFinished) return;
    if (i === preguntas[quizIndex].a) setQuizScore((s) => s + 1);
    if (quizIndex + 1 < preguntas.length) {
      setQuizIndex((idx) => idx + 1);
    } else {
      setQuizFinished(true);
    }
  };

  // Reiniciar el quiz
  const reiniciarQuiz = () => {
    setQuizIndex(0);
    setQuizScore(0);
    setQuizFinished(false);
  };

  // -----------------------------------------------------------
  // 5) ACCIÓN DE LOS 3 BOTONES (abre el modal)
  // -----------------------------------------------------------
  const clickAccion = (label) => setSection(label);

  // -----------------------------------------------------------
  // 6) ESTILOS EN-LÍNEA (sin dependencias externas)
  // -----------------------------------------------------------
  const st = {
    page: {
      background: "linear-gradient(135deg, #dbeafe 0%, #e9eff7 35%, #ffe6f2 100%)",
      minHeight: "100vh",
      padding: "28px 16px 40px",
      textAlign: "center",
      fontFamily:
        "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif",
      color: "#0f172a",
    },
    titleBar: {
      margin: "0 auto 20px",
      width: "min(760px, 92vw)",
      height: 56,
      background: "rgba(255,255,255,.75)",
      border: "1px solid rgba(203,213,225,.6)",
      borderRadius: 16,
      backdropFilter: "blur(6px)",
      boxShadow: "0 8px 18px rgba(2,8,23,.10), inset 0 2px 6px rgba(2,8,23,.06)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      letterSpacing: 0.8,
      fontWeight: 900,
      fontSize: 20,
      textTransform: "uppercase",
    },
    gallery: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      flexWrap: "wrap",
      marginBottom: 24,
    },
    img: {
      width: "220px",
      height: "160px",
      borderRadius: "14px",
      cursor: "pointer",
      objectFit: "cover",
      background: "#fff",
      boxShadow: "0 6px 16px rgba(2,8,23,.10)",
      transition: "transform .2s ease, box-shadow .2s ease",
    },
    actions: {
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(200px, 1fr))",
      gap: 18,
      width: "min(980px, 96vw)",
    },
    actionBtn: {
      background: "#50e3c2",
      color: "#075e55",
      border: "none",
      borderRadius: 16,
      height: 72,
      display: "grid",
      gridTemplateColumns: "56px 1fr",
      alignItems: "center",
      padding: "0 18px",
      fontWeight: 800,
      letterSpacing: 0.4,
      boxShadow: "0 10px 24px rgba(16,185,129,.25)",
      cursor: "pointer",
      transition: "transform .12s ease, box-shadow .12s ease",
    },
    actionIcon: {
      width: 48,
      height: 48,
      borderRadius: 12,
      background: "rgba(255,255,255,.75)",
      display: "grid",
      placeItems: "center",
      fontSize: 26,
      fontWeight: 800,
    },
    actionText: { textAlign: "left", fontSize: 16 },

    // Modal
    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,.45)",
      display: "grid",
      placeItems: "center",
      zIndex: 1000,
      padding: 16,
    },
    modal: {
      width: "min(920px, 95vw)",
      background: "#fff",
      borderRadius: 16,
      boxShadow: "0 20px 50px rgba(0,0,0,.25)",
      padding: 16,
      textAlign: "left",
      maxHeight: "85vh",
      display: "flex",
      flexDirection: "column",
    },
    mhead: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid #e2e8f0",
      paddingBottom: 10,
      marginBottom: 12,
    },
    mtitle: { margin: 0, fontSize: 20 },
    close: {
      background: "transparent",
      border: "1px solid #cbd5e1",
      borderRadius: 8,
      padding: "6px 10px",
      cursor: "pointer",
      fontWeight: 700,
    },
    mcontent: { overflow: "auto", paddingRight: 6 },

    // tipografía/estructura del contenido
    h3: { margin: "14px 0 6px" },
    p: { margin: "6px 0", color: "#334155", lineHeight: 1.55 },
    ul: { margin: "4px 0 10px 18px", color: "#334155" },
    li: { margin: "4px 0" },

    // quiz
    quizQ: { fontWeight: 800, marginBottom: 10 },
    quizOpt: {
      display: "block",
      width: "100%",
      textAlign: "left",
      margin: "8px 0",
      padding: "10px 12px",
      border: "1px solid #cbd5e1",
      borderRadius: 10,
      background: "#fff",
      cursor: "pointer",
      fontWeight: 600,
    },
    quizFoot: {
      marginTop: 12,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    quizBtn: {
      border: "none",
      borderRadius: 10,
      padding: "8px 12px",
      background: "#3b82f6",
      color: "#fff",
      cursor: "pointer",
      fontWeight: 700,
    },
  };

  // -----------------------------------------------------------
  // 7) EFECTO HOVER DE LAS IMÁGENES DE LA GALERÍA
  // -----------------------------------------------------------
  const onImgHover = (e, enter) => {
    e.currentTarget.style.transform = enter ? "translateY(-2px)" : "none";
    e.currentTarget.style.boxShadow = enter
      ? "0 14px 28px rgba(2,8,23,.18)"
      : "0 6px 16px rgba(2,8,23,.10)";
  };

  // -----------------------------------------------------------
  // 8) CONTENIDO DEL MODAL: SECCIÓN "MASCOTAS"
  // -----------------------------------------------------------
  const ContenidoMascotas = () => (
    <div>
      <h3 style={st.h3}>Cuidados Generales</h3>
      <ul style={st.ul}>
        <li style={st.li}><b>Alimentación:</b> dieta balanceada acorde a la especie y etapa (cachorro/adulto/senior).</li>
        <li style={st.li}><b>Agua fresca:</b> disponible todo el día.</li>
        <li style={st.li}><b>Vacunas y desparasitación:</b> esquema actualizado; desparasitar cada 3–4 meses.</li>
        <li style={st.li}><b>Higiene:</b> baño (según especie), cepillado, limpieza de oídos y corte de uñas.</li>
        <li style={st.li}><b>Ejercicio/Enriquecimiento:</b> paseos, juegos, rascadores, rompecabezas.</li>
        <li style={st.li}><b>Identificación:</b> placa y microchip si es posible.</li>
        <li style={st.li}><b>Chequeos veterinarios:</b> 1–2 veces al año o ante cambios de conducta/apetito.</li>
      </ul>

      <h3 style={st.h3}>Según Especie</h3>
      <p style={st.p}><b>Felinos:</b> arenero limpio, rascadores, lugares altos, ambiente predecible.</p>
      <p style={st.p}><b>Caninos:</b> paseos diarios, socialización positiva, educación básica.</p>
      <p style={st.p}><b>Roedores:</b> jaula amplia, material para roer, limpieza frecuente.</p>
      <p style={st.p}><b>Aves:</b> jaula segura, perchas, variedad de frutas/verduras (no solo semillas).</p>
      <p style={st.p}><b>Otros:</b> consultar requerimientos específicos (temperatura, UVB, humedad, sustrato).</p>

      <h3 style={st.h3}>Señales de Alerta</h3>
      <ul style={st.ul}>
        <li style={st.li}>Vómitos y diarrea persistentes, sangre en heces.</li>
        <li style={st.li}>Fiebre, decaimiento, inapetencia &gt; 24h.</li>
        <li style={st.li}>Dificultad respiratoria, tos, convulsiones.</li>
        <li style={st.li}>Dolor evidente, heridas profundas.</li>
      </ul>
      <p style={st.p}><i>Nota: esta información es educativa y no reemplaza la valoración veterinaria.</i></p>
    </div>
  );

  // -----------------------------------------------------------
  // 9) CONTENIDO DEL MODAL: SECCIÓN "NOTICIAS"
  // -----------------------------------------------------------
  const ContenidoNoticias = () => (
    <div>
      <h3 style={st.h3}>Enfermedades más graves en <u>Perros</u></h3>
      <ul style={st.ul}>
        <li style={st.li}><b>Parvovirus canino:</b> vómitos, diarrea hemorrágica, deshidratación. <b>Prevención:</b> vacunación.</li>
        <li style={st.li}><b>Moquillo (Distemper):</b> respiratorio/neurológico. <b>Prevención:</b> vacunación y evitar contacto con enfermos.</li>
        <li style={st.li}><b>Leptospirosis:</b> bacteria transmitida por orina contaminada. <b>Prevención:</b> vacuna y control de roedores.</li>
        <li style={st.li}><b>Rabia:</b> mortal y zoonótica. <b>Prevención:</b> vacunación obligatoria.</li>
        <li style={st.li}><b>Ehrlichiosis/Anaplasmosis:</b> por garrapatas. <b>Prevención:</b> antiparasitarios y chequeos.</li>
      </ul>

      <h3 style={st.h3}>Enfermedades más graves en <u>Gatos</u></h3>
      <ul style={st.ul}>
        <li style={st.li}><b>Panleucopenia felina (parvo felino):</b> alta mortalidad en cachorros. <b>Prevención:</b> vacunación.</li>
        <li style={st.li}><b>Leucemia felina (FeLV):</b> viral, inmunosupresora. <b>Prevención:</b> prueba y vacuna (según riesgo).</li>
        <li style={st.li}><b>Inmunodeficiencia felina (FIV):</b> viral, se transmite por mordidas. <b>Prevención:</b> evitar peleas, esterilizar.</li>
        <li style={st.li}><b>PIF (Peritonitis infecciosa felina):</b> asociada a coronavirus felino mutado. <b>Manejo:</b> diagnóstico temprano.</li>
        <li style={st.li}><b>Rabia:</b> también afecta gatos. <b>Prevención:</b> vacunación.</li>
      </ul>
      <p style={st.p}><i>Recomendación:</i> sigue el plan vacunal y antiparasitario indicado por tu veterinario y realiza chequeos periódicos.</p>
    </div>
  );

  // -----------------------------------------------------------
  // 10) CONTENIDO DEL MODAL: SECCIÓN "QUIZ"
  // -----------------------------------------------------------
  const ContenidoQuiz = () => (
    <div>
      {!quizFinished ? (
        <>
          <div style={st.quizQ}>
            Pregunta {quizIndex + 1} de {preguntas.length}
          </div>
          <p style={st.p}><b>{preguntas[quizIndex].q}</b></p>
          {preguntas[quizIndex].options.map((op, i) => (
            <button key={i} style={st.quizOpt} onClick={() => responder(i)}>
              {op}
            </button>
          ))}
          <div style={st.quizFoot}>
            <span>Puntaje: {quizScore}</span>
            <span>Correctas: {quizScore} / {preguntas.length}</span>
          </div>
        </>
      ) : (
        <>
          <h3 style={st.h3}>¡Resultado!</h3>
          <p style={st.p}>
            Obtuviste <b>{quizScore}</b> de <b>{preguntas.length}</b>.
          </p>
          <button style={st.quizBtn} onClick={reiniciarQuiz}>
            Reiniciar Quiz
          </button>
        </>
      )}
    </div>
  );

  // -----------------------------------------------------------
  // 11) MODAL GENÉRICO (renderiza el contenido según 'section')
  // -----------------------------------------------------------
  const ModalSeccion = () => {
    if (!section) return null;
    return (
      <div style={st.overlay} onClick={() => setSection(null)}>
        <div style={st.modal} onClick={(e) => e.stopPropagation()}>
          <div style={st.mhead}>
            <h3 style={st.mtitle}>{section}</h3>
            <button style={st.close} onClick={() => setSection(null)}>Cerrar</button>
          </div>
          <div style={st.mcontent}>
            {section === "MASCOTAS" && <ContenidoMascotas />}
            {section === "NOTICIAS" && <ContenidoNoticias />}
            {section === "QUIZ" && <ContenidoQuiz />}
          </div>
        </div>
      </div>
    );
  };

  // -----------------------------------------------------------
  // 12) RENDER PRINCIPAL
  // -----------------------------------------------------------
  return (
    <div style={st.page}>
      {/* Título superior (conserva tu texto original) */}
      <h1 style={{ fontSize: "40px", margin: "10px 0 12px" }}>MASCOTICAS SENA</h1>

      {/* Barra flotante con el mismo título */}
      <div style={st.titleBar}>MASCOTICAS SENA</div>

      {/* Galería de imágenes (mantiene tu lógica de click) */}
      <div style={st.gallery}>
        {imagenes.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`Mascota ${i + 1}`}
            style={st.img}
            onClick={() => mostrarInfo(`Mascota ${i + 1}`)}
            onMouseEnter={(e) => onImgHover(e, true)}
            onMouseLeave={(e) => onImgHover(e, false)}
            onError={(e) => { e.currentTarget.src = "https://via.placeholder.com/220x160?text=Mascotas"; }}
          />
        ))}
      </div>

      {/* Botones grandes para abrir cada sección en el modal */}
      <div style={st.actions}>
        {[
          { icon: "🐾", label: "MASCOTAS" },
          { icon: "ℹ️", label: "NOTICIAS" },
          { icon: "❓", label: "QUIZ" },
        ].map((b, i) => (
          <button
            key={i}
            onClick={() => clickAccion(b.label)}
            style={st.actionBtn}
            onMouseDown={(e) => (e.currentTarget.style.transform = "scale(.98)")}
            onMouseUp={(e) => (e.currentTarget.style.transform = "none")}
          >
            <div style={st.actionIcon}>{b.icon}</div>
            <div style={st.actionText}>{b.label}</div>
          </button>
        ))}
      </div>

      {/* Botones de administración (opcionales) */}
      {adminLogueado && (
        <div style={{ marginTop: "30px" }}>
          <button
            onClick={exportarUsuarios}
            style={{
              padding: "10px 20px",
              backgroundColor: "#28a745",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              margin: "0 10px",
            }}
          >
            Exportar Usuarios
          </button>
          <button
            onClick={exportarLogins}
            style={{
              padding: "10px 20px",
              backgroundColor: "#17a2b8",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              margin: "0 10px",
            }}
          >
            Exportar Logins
          </button>
        </div>
      )}

      {/* Modal con el contenido elegido */}
      <ModalSeccion />
    </div>
  );
}

export default PrimerComponente;
